import React from 'react'
import Button from '@material-ui/core/Button';
import styles from './ResourcesButton.module.css'
import {Link} from "react-router-dom";

function ResourcesButton({title,icon,linkPath}) {
    return (
        <>
            <Link to={linkPath} className={styles.resourceLink}>
                <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<i className={icon} />}
                className={styles.component}
                >
                    {title}
                </Button>
            </Link>
        </>
    )
}

export default ResourcesButton
